import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Star: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M14.65 4.45a1.75 1.75 0 0 1 3.12 0l.06.13 2.77 6.67 7.2.58a1.75 1.75 0 0 1 1 3.07l-5.48 4.7 1.67 7.04a1.75 1.75 0 0 1-2.61 1.9l-6.17-3.77-6.17 3.77a1.75 1.75 0 0 1-2.61-1.9L9.1 19.6l-5.49-4.7a1.75 1.75 0 0 1 1-3.08l7.2-.58 2.78-6.67.06-.13Zm-1.04 7.71c-.26.6-.83 1.02-1.48 1.07l-6.76.54 5.15 4.42c.5.42.72 1.1.57 1.73l-1.58 6.6 5.79-3.54.21-.11c.45-.2.95-.2 1.4 0l.21.11 5.79 3.54-1.57-6.6c-.16-.64.06-1.3.56-1.73l5.15-4.42-6.76-.54a1.75 1.75 0 0 1-1.48-1.07l-2.6-6.26-2.6 6.26Z"
    />
  </Icon>
);
